import React, { useEffect, useState } from "react";
import { CgAdd, CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { BiPlus } from "react-icons/bi";

const MuqeemTableEdit = ({ apiDatas, SET_MUQEEM_POINTS, setAllowEdit }) => {
  const muqueem_titles = [
    "SL. No",
    "PARTICULARS",
    "MUQEEM POINTS DEDUCTION",
    "EQUIVALENT SAR FOR MUQEEM POINTS",
    "TO BE PAID BY",
    "ACTION",
  ];

  const [muqueemList, setMuqueemList] = useState([
    {
      particular: "",
      deduction: "0",
      equivalent_sar: "0",
      paid_by: "",
    },
  ]);

  useEffect(() => {
    if (apiDatas?.contract_muqeem_points?.length > 0)
      setMuqueemList([...apiDatas?.contract_muqeem_points]);
  }, [apiDatas]);

  const addNewRow = () => {
    setMuqueemList([
      ...muqueemList,
      {
        particular: "",
        deduction: "",
        equivalent_sar: "",
        paid_by: "",
      },
    ]);
    setAllowEdit(true);
  };

  const deleteRow = (index) => {
    if (muqueemList.length <= 1) return false;
    const updatedRows = [...muqueemList];
    updatedRows.splice(index, 1);
    setMuqueemList(updatedRows);
    setAllowEdit(true);
  };

  const updateRow = (property, updatedValue, rowIndex) => {
    const updatedList = [...muqueemList];
    updatedList[rowIndex][property] = updatedValue;
    setMuqueemList(updatedList);
    setAllowEdit(true);
  };

  useEffect(() => {
    SET_MUQEEM_POINTS(muqueemList);
  }, [muqueemList]);

  return (
    <>
      <div className="pt-2 ">
        <div className="font-semibold text-xl mt-10 mb-2">
          MUQEEM POINTS DEDUCTION SUMMARY
        </div>
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block uppercase">{`Slide / scroll to right >`}</p>
        <div
          className={`grid justify-items-center grid-cols-table-5 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {muqueem_titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {muqueemList?.map((list, index) => (
            <React.Fragment key={index + list.particular}>
              <p>{index + 1}</p>
              <textarea
                className="textarea-sm rounded-sm resize-y w-full h-20  bg-slate-100"
                type="text"
                defaultValue={list.particular}
                onChange={(e) =>
                  updateRow("particular", e.target.value?.toUpperCase(), index)
                }
                placeholder="ENTER PARTICULAR"
                required
              />
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="number"
                value={list.deduction}
                onChange={(e) => updateRow("deduction", e.target.value, index)}
                pattern="[0-9]*"
                placeholder="MUQEEM POINTS DEDUCTION"
                required
              />
              <input
                className="input-sm rounded-sm bg-slate-100"
                type="number"
                value={list.equivalent_sar}
                onChange={(e) =>
                  updateRow("equivalent_sar", e.target.value, index)
                }
                pattern="[0-9]*"
                required
                placeholder="ENTER EQUIVALENT SAR FOR MUQEEM POINTS"
              />
              <textarea
                className="textarea-sm rounded-sm bg-slate-100"
                type="text"
                defaultValue={list.paid_by}
                onChange={(e) =>
                  updateRow("paid_by", e.target.value?.toUpperCase(), index)
                }
                placeholder="ENTER TO BE PAID"
                required
              />
              <div className="flex gap-3 w-20 justify-start">
                <button
                  type="button"
                  className={`p-1 px-2 rounded-md ring-1 ring-red bg-red text-white disabled:bg-rose-400 disabled:cursor-not-allowed `}
                  onClick={() => deleteRow(index)}
                  disabled={muqueemList?.length <= 1}
                  title={`${
                    muqueemList?.length <= 1 && "At least one row required"
                  }`}
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
                {index === muqueemList?.length - 1 && (
                  <button
                    className={`p-1 px-2 rounded-md ring-1 ring-slate-600 `}
                    onClick={addNewRow}
                  >
                    <BiPlus size={"1.4rem"} />
                  </button>
                )}
              </div>
              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-6 `}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default MuqeemTableEdit;
